<template>
    <div class="smr-input" :class="{'smr-input--clearable' : clearable, 'smr-input--focused' : focused, 'smr-input--error' : error}">
        <el-input 
            ref="inputElement"
            v-model="data" 
            :type="inputType"
            :placeholder="placeholder"
            :maxlength="maxlength"
            @input="inputHandler"
            @focus="focusHandler"
            @blur="blurHandler"
            >
        </el-input>
        <div class="smr-input__clear" v-if="clearable && this.data !== ''" @click="clearClickHandler">
            <Icon view-box="0 0 21 21" :width="21" :height="21">
                <IconCloseCircle />
            </Icon>
        </div>
        <div v-if="error" class="smr-input__error-indicator red">
            <Icon viewBox="0 0 20 20" :size="20">
                <IconAlertCircle />
            </Icon>
        </div>
    </div>
</template>

<script>
import Icon from '@/components/Icon.vue'
import IconCloseCircle from '@/components/icons/IconCloseCircle.vue'
import IconAlertCircle from '@/components/icons/IconAlertCircle.vue'

export default {
    props: {
        value: {
            type: [String, Number],
            default: ''
        },
        inputType: {
            type: String,
            default: 'text'
        },
        placeholder: {
            type: String,
            default: 'text'
        },
        clearable: {
            type: Boolean,
            default: false
        },
        maxlength: {
            type: [Number, String],
            default: ''
        },
        error: {
            type: Boolean,
            default: false
        },
    },
    components: {
        Icon,
        IconCloseCircle,
        IconAlertCircle
    },
    data() {
        return {
            data: '',
            focused: false,
        }
    },
    watch: {
        value(newVal) {
            this.data = newVal
        }
    },
    mounted() {
        this.setInitialValue()
    },
    beforeDestroy() {
        this.removeListeners
    },
    methods: {
        inputHandler() {
            this.emitChange()
        },
        focusHandler() {
            this.focused = true
        },
        blurHandler() {
            setTimeout(() => {
                this.focused = false
            }, 100);
        },
        clearClickHandler() {
            this.data = ''
            this.$refs.inputElement.focus()
            setTimeout(() => {
                this.emitChange()
            }, 50);
        },
        setInitialValue() {
            if(this.value) {
                this.data = this.value
            }
        },
        emitChange() {
            this.$emit('change', this.data);
        },
        focus() {
           this.$refs.inputElement.focus() 
        }
    }
}
</script>

<style lang="scss">
.smr-input {
    $block: &;
    position: relative;

    &--clearable {
        .el-input,
        .el-textarea {
            &__inner {
                padding-right: 40px;
            }
        }
    }

    &--focused {
        #{$block}__clear {
            opacity: 1;
            pointer-events: auto;
        }
    }

    &--error {
        .el-input {
            &__inner {
                box-shadow: inset 0px 0px 0px 1px $color-red;
            }
        }
    }

    &--small {
       max-width: 72px;

       .el-input__inner {
        text-align: center; 
       }
    }

   .el-input,
   .el-textarea {
       &__inner {
            background-color: $color-black-005;
            border-radius: 8px;
            height: 34px;
            border: none;
            font-size: 15px;
            color: $color-black;

            &::placeholder {
                color: $color-black-04;
            }
       }
   } 

   .el-textarea {
       &__inner {
           height: 96px;
           resize: none;
       }
   }

   .el-input {

        input::-webkit-outer-spin-button,
        input::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }

        input[type=number] {
            -moz-appearance: textfield;
        }
   }

   &__clear {
       position: absolute;
       top: 50%;
       right: 8px;
       transform: translateY(-50%);
       line-height: 0;
       opacity: 0;
       pointer-events: none;
       cursor: pointer;
   }

   &__error-indicator {
    position: absolute;
       top: 50%;
       right: 8px;
       transform: translateY(-50%);
       line-height: 0;
       pointer-events: none;
   }
}
</style>